import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';
import theme from '../../theme';

const StyledDiv = styledComponent('div', {
  '& .summary-header': {
    marginBottom: theme.spacing.gapXl,
  },

  '& .runs-container': {
    overflowX: 'auto',
    marginTop: theme.spacing.gapXl,
  },

  '& .run': {
    marginBottom: theme.spacing.bodyPadding,
  },

  '& .run-title': {
    marginBottom: theme.spacing.gapLg,
    color: theme.colors.text,
  },

  '& .vehicle-table': {
    width: '100%',
    fontSize: theme.sizes.smallFontSize,
    textAlign: 'center',
    borderCollapse: 'collapse',
  },

  '& .traffic-section': {
    marginTop: theme.spacing.fieldGap,
  },

  '& .traffic-title': {
    marginBottom: theme.spacing.gapMd,
    color: theme.colors.textMuted,
  },

  '& .traffic-table': {
    width: '100%',
    fontSize: theme.typography.hint.fontSize,
    borderCollapse: 'collapse',
  },

  '& .traffic-table th, & .traffic-table td': {
    textAlign: 'left',
    padding: theme.spacing.labelGap,
  },
});

function SubmissionSummary({ data }) {
  return (
    <StyledDiv>
      <div className="summary-header">
        <b>Drop-Off Date:</b> {data.dropOffDate}
        <br />
        <b>Fulfillment Centers:</b> {data.fulfillmentCenters.join(', ')}
        <br />
        <b>Total Submissions:</b> {data.vehicles.length}
      </div>

      <div className="runs-container">
        {data.vehicles.map((run, runIndex) => (
          <div key={run.fulfillmentCenter} className="run">
            <h5 className="run-title">
              Run {runIndex + 1}: {run.fulfillmentCenter}
            </h5>
            <table className="vehicle-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Capacity</th>
                  <th>Shift Start</th>
                  <th>Target End</th>
                  <th>Shift End</th>
                  <th>Lat</th>
                  <th>Long</th>
                  <th>Skill Set</th>
                </tr>
              </thead>
              <tbody>
                {run.vehicles.map((v) => (
                  <tr key={v.id}>
                    <td>{v.id}</td>
                    <td>{v.capacity}</td>
                    <td>{v.shiftStartTime}</td>
                    <td>{v.targetShiftEndTime}</td>
                    <td>{v.shiftEndTime}</td>
                    <td>{v.lat}</td>
                    <td>{v.long}</td>
                    <td>{v.skillSet}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {run.trafficConfiguration?.length > 0 && (
              <div className="traffic-section">
                <h6 className="traffic-title">Traffic Configuration</h6>
                <table className="traffic-table">
                  <thead>
                    <tr>
                      <th>Day Type</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>Multiplier</th>
                    </tr>
                  </thead>
                  <tbody>
                    {run.trafficConfiguration.map((w) => (
                      <tr key={`${w.dayType}-${w.startTime}-${w.endTime}`}>
                        <td>{w.dayType}</td>
                        <td>{w.startTime}</td>
                        <td>{w.endTime}</td>
                        <td>{w.trafficMultiplier}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </StyledDiv>
  );
}

SubmissionSummary.propTypes = {
  data: PropTypes.shape({
    dropOffDate: PropTypes.string.isRequired,
    fulfillmentCenters: PropTypes.arrayOf(PropTypes.string).isRequired,
    vehicles: PropTypes.arrayOf(
      PropTypes.shape({
        fulfillmentCenter: PropTypes.string.isRequired,
        vehicles: PropTypes.arrayOf(PropTypes.object).isRequired,
        trafficConfiguration: PropTypes.arrayOf(PropTypes.object),
      }),
    ).isRequired,
  }).isRequired,
};

export default SubmissionSummary;
